import React, { Component } from "react"
import { postIntegrationSuggestion } from "app/modules/integrations/api"
import { Button, Input, Modal } from "@driftt/tide-core-legacy"
import withNotifications from "components/shared/notifications"

import "./style.styl"

class SuggestIntegrationModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      integrationSuggestion: ""
    }
  }

  handleChange = e => {
    this.setState({ integrationSuggestion: e.target.value })
  }

  sendSuggestion = async () => {
    const { onClose, notifications } = this.props
    try {
      await postIntegrationSuggestion(this.state.integrationSuggestion)
      this.setState({integrationSuggestion: ""}, () => {
        notifications.success("We received your request. Thanks for suggesting an integration!")
        onClose()
      })
    } catch (e) {
      console.error(e)
    }
  }

  render() {
    const { integrationSuggestion } = this.state
    const hasSuggestion =
      integrationSuggestion && integrationSuggestion.length > 0

    return (
      <div>
        <Modal
          className="integration-suggestion-modal"
          open={this.props.open}
          size={this.props.size}
          onClose={this.props.onClose}
        >
          <h1 className="integration-suggestion-header">
            What integration do you want to see in Drift?
          </h1>
          <Input
            className="integration-suggestion-input"
            type="text"
            placeholder="Integration name"
            onChange={this.handleChange}
          />

          <Button
            className="integration-suggestion-button"
            disabled={!hasSuggestion}
            onClick={this.sendSuggestion}
          >
            Suggest integration
          </Button>
        </Modal>
      </div>
    )
  }
}

export default withNotifications(SuggestIntegrationModal)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/SuggestIntegrationModal/index.js